$("[data-popup='close']").click(function(e){
	if ($(e.target).attr("data-popup") === "close") {
		$('body').removeClass('no-scroll');
		$(this).closest('.popup').removeClass('active');
	}
});
